import { ComponentProps } from 'react';

/**
 * Inline SVG for the animated Spotlight overlay shapes.
 *
 * Rendered inline (not via <img src>) so the overlay color can be driven by
 * the `bg.surface` semantic token via Chakra's CSS variable. See the sibling
 * `spotlight-background-1.tsx` for the full rationale.
 */
export const SpotlightBackground2 = ({ preserveAspectRatio = 'xMidYMid slice', ...rest }: ComponentProps<'svg'>) => {
	const overlayColor = 'var(--chakra-colors-bg-surface)';

	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 2200 1200"
			fill="none"
			preserveAspectRatio={preserveAspectRatio}
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			style={{ display: 'block' }}
			{...rest}
		>
			<defs>
				<linearGradient id="spotlight-bg-2-gradient-0" x1="122.388" y1="190.746" x2="1558.85" y2="1821.5" gradientUnits="userSpaceOnUse">
					<stop stopColor={overlayColor} stopOpacity="0.6" />
					<stop offset="0.461538" stopColor={overlayColor} stopOpacity="0.2" />
					<stop offset="1" stopColor={overlayColor} stopOpacity="0.4" />
				</linearGradient>
				<linearGradient id="spotlight-bg-2-gradient-1" x1="374.416" y1="1224.35" x2="1331.29" y2="420.24" gradientUnits="userSpaceOnUse">
					<stop stopColor={overlayColor} stopOpacity="0.2" />
					<stop offset="0.461538" stopColor={overlayColor} stopOpacity="0.2" />
					<stop offset="1" stopColor={overlayColor} stopOpacity="0.4" />
				</linearGradient>
				<linearGradient id="spotlight-bg-2-gradient-2" x1="1166.33" y1="930.249" x2="528.368" y2="1023.42" gradientUnits="userSpaceOnUse">
					<stop stopColor={overlayColor} stopOpacity="0.6" />
					<stop offset="0.461538" stopColor={overlayColor} stopOpacity="0.2" />
					<stop offset="1" stopColor={overlayColor} stopOpacity="0.4" />
				</linearGradient>
			</defs>
			<g opacity="0.7">
				<path
					d="M1632.33 661.144C1844.67 1013.22 1594.33 1371.12 1442.61 1506.06C1442.61 1506.06 936.557 2042.54 631.839 1937.79C327.122 1833.04 -509.928 801.613 -95.8741 383.04C380.287 -98.3189 1366.9 221.044 1632.33 661.144Z"
					fill="url(#spotlight-bg-2-gradient-0)"
				/>
				<path
					d="M665.093 362.461C870.373 245.079 1072.81 393.812 1148.36 482.851C1148.36 482.851 1450.06 781.002 1385.75 954.807C1321.44 1128.61 717.191 1596.1 482.061 1352.42C211.661 1072.2 408.492 509.188 665.093 362.461Z"
					fill="url(#spotlight-bg-2-gradient-1)"
				/>
				<path
					d="M804.969 1229.52C683.061 1225.32 634.601 1105.15 625.609 1045.58C625.609 1045.58 574.141 832.929 649.509 774.124C724.876 715.319 1116.8 674.16 1153.85 844.857C1196.45 1041.16 957.353 1234.76 804.969 1229.52Z"
					fill="url(#spotlight-bg-2-gradient-2)"
				/>
			</g>
		</svg>
	);
};
